<app-root-document-viewer
  [documentUrl]="documentUrl"
  [isMissingFile]="isMissingFile"
  [validateButtonLabel]="validateButtonLabel"
  [isValidateDisabled]="isValidateDisabled"
  cancelButtonLabel="Enregistrer et quitter"
  optionnalButton1Label="Transmettre au partenaire"
  [isOptionnalButton1Disabled]="isTransferToPartenaireDisabled"
  optionnalButtonColor="valid"
  (onValidate)="validate()"
  (onCancel)="close.emit()"
  (onOptionnalButton1Click)="transferToPartenaire()">
  <div class="flex-vertical" left-panel>
    <div id="target_div" class="display-none"></div>
    <div class="flex-vertical padding-24 gap-16">
      <h5>Contrôle des documents</h5>
      <div class="flex-vertical gap-16 flex-start">
        <oui-button type="text" iconPrefix="unknown_document" (click)="onMissingFile()">
          Déclarer un document manquant
        </oui-button>
        @if (!isFileUploading) {
          <oui-button type="text" iconPrefix="add_circle_outline" (click)="onAddFichierOperation()"
            >Ajouter un document</oui-button
          >
        }
        @if (isFileUploading) {
          <div class="flex-horizontal align-self-center">
            <oui-loading size="small"></oui-loading>
          </div>
        }
      </div>
    </div>
    <div>
      @if (fichiersAControler) {
        <oui-accordion [expanded]="fichiersAControler.length > 0" [disabled]="fichiersAControler.length < 1">
          <oui-accordion-header class="padding-vertical-8 padding-lateral-24 background-background">
            <oui-accordion-title class="color-alert subtitle-1">{{
              formatTitleWithCount('A contrôler', fichiersAControler.length, false)
            }}</oui-accordion-title>
          </oui-accordion-header>
          <div class="flex-vertical">
            @for (file of fichiersAControler; track file) {
              <app-file-item
                [fileName]="file.metadata?.fileName ?? undefined"
                [label]="getFileLabel(file)"
                [selected]="selectedFile.id === file.id"
                [status]="file.fileId ? 'a_controler' : 'manquant'"
                (click)="selectFile(file)"></app-file-item>
            }
          </div>
        </oui-accordion>
      }
      @if (fichiersNonConformes) {
        <oui-accordion [expanded]="fichiersNonConformes.length > 0" [disabled]="fichiersNonConformes.length < 1">
          <oui-accordion-header class="padding-vertical-8 padding-lateral-24 background-background">
            <oui-accordion-title class="color-error subtitle-1">{{
              formatTitleWithCount('Non conforme', fichiersNonConformes.length)
            }}</oui-accordion-title>
          </oui-accordion-header>
          <div class="flex-vertical">
            @for (file of fichiersNonConformes; track file) {
              <app-file-item
                [fileName]="$safeNavigationMigration(file.metadata?.fileName)"
                [label]="getFileLabel(file)"
                [selected]="selectedFile.id === file.id"
                [status]="file.fileId ? 'a_corriger' : 'manquant'"
                (click)="selectFile(file)"></app-file-item>
            }
          </div>
        </oui-accordion>
      }
      @if (fichiersConformes) {
        <oui-accordion [expanded]="fichiersConformes.length > 0" [disabled]="fichiersConformes.length < 1">
          <oui-accordion-header class="padding-vertical-8 padding-lateral-24 background-background">
            <oui-accordion-title class="color-valid subtitle-1">{{
              formatTitleWithCount('Conforme', fichiersConformes.length)
            }}</oui-accordion-title>
          </oui-accordion-header>
          <div class="flex-vertical">
            @for (file of fichiersConformes; track file) {
              <app-file-item
                [fileName]="file.metadata?.fileName ?? undefined"
                [label]="getFileLabel(file)"
                [selected]="selectedFile.id === file.id"
                status="conforme"
                (click)="selectFile(file)"></app-file-item>
            }
          </div>
        </oui-accordion>
      }
    </div>
  </div>

  @if (hideNonConformPanel) {
    <ng-container right-panel>
      <lib-document-viewer-header
        [documentName]="getFileLabel(selectedFile)"
        [fileName]="selectedFile.metadata?.fileName ?? undefined"
        [menu]="!showUpdateFileForm ? fileMenu : undefined"
        [dateAjout]="$safeNavigationMigration(selectedFile.metadata?.dateDeCreation)"
        [showCloseButton]="false"></lib-document-viewer-header>
      @if (!showUpdateFileForm && selectedFile.commentaire) {
        <div class="flex-vertical">
          <div class="body-2 color-on-surface-medium">Commentaire</div>
          <div class="body-2 color-on-surface-emphasis" [innerText]="selectedFile.commentaire"></div>
        </div>
      }
      @if (!showUpdateFileForm) {
        @if (selectedFile.reponseConsultant && !isConformFile) {
          <div class="padding-16 flex-vertical gap-16 orangeFrame">
            <div class="subtitle-2 color-alert">Réponse du consultant:</div>
            <div class="body-2" [innerText]="selectedFile.reponseConsultant"></div>
          </div>
        }
        @if (isConformFile && !isUpdating) {
          <div class="flex-vertical gap-24">
            <app-file-conform-status-stamp [historyEntries]="selectedFile.historyEntry"></app-file-conform-status-stamp>
            @if (isCancelConformityDeclarationPossible) {
              <div class="flex-horizontal justify-center">
                <oui-button type="text" iconPrefix="undo" (click)="onCancelCompliance()"
                  >Annuler la déclaration</oui-button
                >
              </div>
            }
          </div>
        }
        @if (selectedFile.fileId || isUpdating) {
          <div class="flex-vertical gap-16">
            @if (!isUpdating) {
              @if (showConformButton) {
                <oui-button type="contained" color="valid" iconPrefix="check" (click)="onCompliant()"
                  >Déclarer conforme</oui-button
                >
              }
              @if (showAddNonComplianceButton) {
                <oui-button type="contained" color="error" iconPrefix="add" (click)="onAddNonCompliance()"
                  >Ajouter une non-conformité</oui-button
                >
              }
              @if (isInstanceMode) {
                @if (isInstanceMode) {
                  <oui-button type="contained" iconPrefix="add" color="error" (click)="onAddInstanceMode()"
                    >Ajouter une instance partenaire</oui-button
                  >
                }
              }
              @if (!isInstanceMode && showAddNonComplianceButton) {
                <oui-button
                  type="outlined"
                  iconPrefix="content_copy"
                  color="error"
                  (click)="onDuplicateNC()"
                  [disabled]="!(selectedFile.fileId && fileSimilarNCs && fileSimilarNCs.length > 0)"
                  >Dupliquer une non-conformité</oui-button
                >
              }
              <!-- FIXME waiting for API document update and its implementation -->
              <!-- <div *ngIf="shouldDocBeTyped(selectedFile)" class="width-100pc margin-bottom-16 top-margin-16">
                        Veuillez sélectionner un type pour ce document:
                        <oui-autocomplete
                          #typeDocumentControl
                          label="Type du document"
                          [control]="boxDocumentTypeControl"
                          [options]="boxDocumentTypeListOptions"
                          class="width-100pc top-margin-8">
                        </oui-autocomplete>
                        <oui-button
                          type="outlined"
                          *ngIf="authService.isAdminRole()"
                          (click)="onCreateNewBoxDocumentType()"
                          class="width-100pc top-margin-8"
                          >Créer un nouveau type</oui-button
                          >
                        </div> -->
              @if (files.length > 1 && showConformButton) {
                <oui-button
                  type="text"
                  iconPrefix="delete"
                  class="deleteButton"
                  (click)="onRemoveFichierFromOperation()"
                  >Supprimer le document</oui-button
                >
              }
            } @else {
              <div class="flex-horizontal align-self-center">
                <oui-loading size="small"></oui-loading>
              </div>
            }
          </div>
        }
        @if (!isInstanceMode) {
          <div class="ncContainer">
            @if (!!nonConformiteList && nonConformiteList.length > 0) {
              <app-non-conformite-accordion
                [NCs]="nonConformiteList"
                [isShowMenu]="true"
                (onCloseNC)="closeNonConformite($event)"
                (onEditNC)="openNonConformiteFichierForm($event)"></app-non-conformite-accordion>
            }
            @if (!!closedNCsList && closedNCsList.length > 0) {
              <app-non-conformite-accordion
                [NCs]="closedNCsList"
                [isShowMenu]="true"
                [title]="'Non-conformités fermées'"
                titleClass="color-secondary subtitle-1"
                (onreOpenNC)="reOpenNonConformite($event)"></app-non-conformite-accordion>
            }
          </div>
        }
        @if (isInstanceMode) {
          <div class="ncContainer">
            @if (!!instancesList && instancesList.length) {
              <app-non-conformite-accordion
                [NCs]="instancesList"
                [isShowMenu]="true"
                [title]="'Instances partenaire ouvertes'"
                (onCloseNC)="closeNonConformite($event)"
                (onEditNC)="openNonConformiteFichierForm($event)"></app-non-conformite-accordion>
            }
            @if (!!closedIPsList && closedIPsList.length > 0) {
              <app-non-conformite-accordion
                [NCs]="closedIPsList"
                [isShowMenu]="true"
                [title]="'Instances partenaire fermées'"
                titleClass="color-secondary subtitle-1"
                (onreOpenNC)="reOpenNonConformite($event)"></app-non-conformite-accordion>
            }
          </div>
        }
      } @else {
        <div class="flex-horizontal justify-center padding-16"><oui-loading></oui-loading></div>
      }
    </ng-container>
  } @else {
    <ng-container right-panel>
      <app-operation-file-non-conform-form
        (onNonConformiteAdd)="createNonCompliance($event)"
        (onNonConformiteEdit)="updateNonConformiteFields($event)"
        [editNC]="nonConformiteToEdit"
        (onInstanceSetIsInternal)="setIsInternalInstance($event)"
        [isInstanceMode]="isInstanceMode">
      </app-operation-file-non-conform-form>
    </ng-container>
  }
</app-root-document-viewer>
